import type {ImageProps} from 'next/image';

export const DEVELOPMENTS_NAV_KEY = 'developments';

export interface DestinationsMenuData {
  // Country/project names are localized by the backend and rendered verbatim
  // (dynamic data — never passed through i18n).
  countries: {key: string; name: string; href: string; flag?: ImageProps['src']}[];
  projects: {id: string; name: string; href: string}[];
  countriesViewAllHref: string;
  projectsViewAllHref: string;
}

// Per the Header stories (ClickUp 869ceg59u / 869cfzfrj): each section shows at
// most this many entries (sorted alphabetically), and the "View All" overflow
// link to the full listing appears only when there are MORE than this many.
export const VIEW_ALL_THRESHOLD = 3;
